import React from "react";
import {useSelector} from "react-redux";
import TableBodyCell from "./TableBodyCell";
import {
    myDataChar_getCategoriesByInvoiceType,
    myDataChar_getInvoiceTypesByRowType, myDataChar_getTypesByCategory,
} from "../../../_data/mydata/myDataChar";
import {
    filterUnusedNumberingModes,
    filterUsedPreNumbers,
} from "../../../_helpers/commonFunctions";
import {numberingModeOptions, preNumberGreek} from "../../../_data/settings/advanced-types-search";

const TableBodyRow = (props) => {
    const {
        dataLength, tableName, columns, updateRowData, rowIndex,
        checkedRows, selectedRowKey, quickEditFields, pRequestData, reqName, emronPaymentsMonth,
        invoiceType, fixedFirstRow, permissionsData
    } = props;
    const data = {...props.data};
    const settings = useSelector((state) => state.SETTINGS.settings);

    const resolveDataKey = (data, tableName) => {
        if (!data) return;
        if (!data.id && data._id) return data["_id"];
        if (!data._id && data.id) return data["id"];
        if (data._id && data.id) return data["_id"];
        if (
            tableName === "Emron Stockholders" ||
            tableName === "Emron Payments" ||
            tableName === "Emron Passwords" ||
            tableName === "New Product My Data" ||
            tableName === "New Price List General" ||
            tableName === "Edit Price List General"
        ) {
            return data["id"];
        }
        if (tableName === "Client New Installations" || tableName === "Supplier New Installations" || tableName === "Company New Installations") {
            return data["no"];
        }
        return "";
    }
    const dataKey = resolveDataKey(data, tableName);

    return (
        <React.Fragment>
            {data
                && columns
                && columns.map((cell, celli) => {
                    let disabled = false;
                    let enableDynamicOptions = false;
                    let dynamicOptions = [];

                    let currentCell = { ...cell };

                    // If it is AI analyzed call, disable inputs and remove delete button
                    if (data?.isAi === true) {
                        disabled = true;
                        if (currentCell.field === "subject") {
                            currentCell.inputType = { ...currentCell.inputType, type: 'textarea' };
                        }

                        if (currentCell.field === "actions" && currentCell.actionButtons) {
                            currentCell.actionButtons = {
                                ...currentCell.actionButtons,
                                delete: false,
                                showAiAnalysis: true,
                            };
                        }
                    }
                    // For Advanced Types Document Numbering
                    if (tableName === "Advanced Types Document Numbering") {
                        if (
                            (cell.field === "preNumber" || cell.field === "number") &&
                            data.numberingMode === "manual"
                        ) {
                            disabled = true;
                        }
                        // Dynamic Options for | It will hide the used prenumbers but not the current
                        if (cell.field === "preNumber") {
                            const etDocumentNumbering = settings.newAdvancedType.documentNumbering;
                            const currentPreNumber = data[cell.field];
                            const currentInstallation = data["installation"];
                            dynamicOptions = filterUsedPreNumbers(preNumberGreek, etDocumentNumbering, currentPreNumber, currentInstallation);
                            enableDynamicOptions = "true";
                        }
                        // Dynamic Options for | It will hide unused modes
                        if (cell.field === "numberingMode") {
                            const etDocumentNumbering = settings.newAdvancedType.documentNumbering;
                            dynamicOptions = filterUnusedNumberingModes(numberingModeOptions, etDocumentNumbering, true);
                            enableDynamicOptions = "true";
                        }
                    } else if (tableName === "Sales Search") {
                        if (cell.field === "number") data.number = data.preNumber + " " + data.number;
                    } else if (tableName === "Edit Advanced Types Document Numbering") {
                        if ((cell.field === "preNumber" || cell.field === "number") && data.numberingMode === "manual") {
                            disabled = true;
                        }
                        // Dynamic Options for | It will hide the used prenumbers from the list on new row
                        if (cell.field === "preNumber") {
                            let etDocumentNumbering = settings.editAdvancedType.documentNumbering;
                            let currentPreNumber = data[cell.field];
                            let currentInstallation = data["installation"];
                            dynamicOptions = filterUsedPreNumbers(preNumberGreek, etDocumentNumbering, currentPreNumber, currentInstallation);
                            enableDynamicOptions = "true";
                        }
                        // Dynamic Options for | It will hide unused modes -- fixes
                        if (cell.field === "numberingMode") {
                            let etDocumentNumbering = settings.editAdvancedType.documentNumbering;
                            dynamicOptions = filterUnusedNumberingModes(numberingModeOptions, etDocumentNumbering, false);
                            enableDynamicOptions = "true";
                        }
                    } else if (tableName === "Search Product Movements") {
                        if (cell.field === "products_list") {
                            if (data.products && data.products.length > 0) data.products_list = data.products.map((item) => item.name);
                        }
                    } else if (tableName === "Sales Modal Products List" || tableName === "MyData Report Classifications") {
                        dynamicOptions = myDataChar_getInvoiceTypesByRowType("income");
                        if (cell.field === "classificationCategory") {
                            dynamicOptions = myDataChar_getCategoriesByInvoiceType("income", invoiceType);
                            enableDynamicOptions = "true";
                        } else if (cell.field === "classificationType") {
                            dynamicOptions = myDataChar_getTypesByCategory("income", invoiceType, data["classificationCategory"]);
                            enableDynamicOptions = "true";
                        }
                    } else if (tableName === "Product Category My Data" || tableName === "New Product My Data" || tableName === "New Fixed Asset My Data") {
                        const rowType = data['rowType'];
                        if (cell.field === "invoiceType") {
                            dynamicOptions = myDataChar_getInvoiceTypesByRowType(rowType);
                            if (tableName === "New Fixed Asset My Data") dynamicOptions = dynamicOptions.filter((el) => el.value === "17.2");
                            enableDynamicOptions = 'true';
                        } else if (cell.field === "category") {
                            dynamicOptions = myDataChar_getCategoriesByInvoiceType(rowType, data["invoiceType"]);
                            enableDynamicOptions = "true";
                        } else if (cell.field === "type") {
                            dynamicOptions = myDataChar_getTypesByCategory(rowType, data["invoiceType"], data["category"]);
                            enableDynamicOptions = "true";
                        } else if (cell.field === "vatExpenseType") {
                            const rowType = data['rowType'];
                            disabled = rowType !== "expense";
                        }
                    } else if (tableName === "MyData Report Classifications Buys") {
                        if (cell.field === "classificationCategory") {
                            dynamicOptions = myDataChar_getCategoriesByInvoiceType("expense", String(data["invoiceType"]));
                            enableDynamicOptions = 'true';
                        } else if (cell.field === "classificationType") {
                            dynamicOptions = myDataChar_getTypesByCategory("expense", String(data["invoiceType"]), String(data["classificationCategory"]));
                            enableDynamicOptions = 'true';
                        }
                    }

                    return (
                        <TableBodyCell
                            reqName={reqName}
                            reqData={pRequestData}
                            quickEditFields={quickEditFields}
                            enableDynamicOptions={enableDynamicOptions}
                            dynamicOptions={dynamicOptions}
                            isInsertRow={false}
                            tableName={tableName}
                            emronPaymentsMonth={emronPaymentsMonth}
                            disabled={disabled}
                            key={celli}
                            celli={celli}
                            columns={columns}
                            rowData={data}
                            dataKey={dataKey}
                            cell={currentCell}
                            data={data[cell.field]}
                            updateRowData={updateRowData}
                            dataLength={dataLength}
                            rowIndex={rowIndex}
                            checkedRows={checkedRows}
                            selectedRowKey={selectedRowKey}
                            fixedFirstRow={fixedFirstRow}
                            permissionsData={permissionsData}
                        />
                    )
                })}
        </React.Fragment>
    )
}
export default TableBodyRow;
